import React from 'react';
import Button, {
    ButtonTypes,
} from 'components/shared/generic/button/presentational/Button';
import SuitsMeLogoBlack from '_content/images/logos/SuitsMe_Logo_Black.png';
import SuitsMeLogoWhite from '_content/images/logos/SuitsMe_Logo_White.png';
import { LOGIN } from '../../../../constants/shared/routes';
import { SUITS_ME_APPLY } from 'lib/constants/routes';
import { useSelector } from 'react-redux';
import { getTheme } from '../../../../selectors/darkMode';

export const Main = () => {
    const isDarkModeEnabled = useSelector(getTheme);

    const logoImage = isDarkModeEnabled ? SuitsMeLogoWhite : SuitsMeLogoBlack;

    return (
        <div className="login-container">
            <img src={logoImage} alt="Logo" className="logo mt-4" />
            <div className="apply-buttons d-flex-col-center mt-3">
                <Button type={ButtonTypes.BUTTON} to={LOGIN}>
                    Login
                </Button>
                <Button
                    type={ButtonTypes.BUTTON}
                    href={SUITS_ME_APPLY}
                    className="applyBtn"
                >
                    Apply
                </Button>
            </div>
        </div>
    );
};
